import 'jquery';
import 'bootstrap';
import 'fullpage.js';
import 'select2';
import 'jasny-bootstrap/dist/js/jasny-bootstrap.min.js'

require('./menu.js');
require('./region.js');
require('./blogIndex.js');
require('./pressIndex.js');
require('./about.js');
require('./courses.js');

$(document).ready(function () {
  $('#fullpage').fullpage({
    slidesNavigation: true,
    controlArrows: false,
    autoScrolling: false,
    fitToSection: false,
    afterRender: function () {
      setInterval(function () {
        $.fn.fullpage.moveSlideRight();
      }, 5000);
    }
  });

  $('body').show();

  $('.project-item-hidden').modal('hide');

  $('.project-img').click(function (e) {
    $(event.target).parent().next().modal('toggle');
  });

  if (window.location.hash) {
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top + 'px'
    }, 500);
  }

});



// WEBPACK FOOTER //
// ./assets/js/index.js